import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/layout/Navigation.jsx';
import Login from './pages/Login.jsx';
import SignupInstructions from './pages/SignupInstructions.jsx';
import ForgotPassword from './pages/ForgotPassword.jsx';
import BusinessType from './pages/BusinessType.jsx';
import RepresentativeDetails from './pages/RepresentativeDetails.jsx';
import ShopDetails from './pages/ShopDetails.jsx';
import ReviewSubmit from './pages/ReviewSubmit.jsx';
import ApplicationSubmitted from './pages/ApplicationSubmitted.jsx';
import TermsAndConditions from './pages/TermsAndConditions.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import ErrorBoundary from './components/ui/ErrorBoundary';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import './App.css';
import './styles/Theme.css';
import './styles/Navigation.css';
import './styles/Login.css';
import './styles/SignupInstructions.css';
import './styles/BusinessType.css';
import './styles/FormStyles.css';
import './styles/TermsAndConditions.css';
import './styles/PrivacyPolicy.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <div className="App">
            <Navigation />
            <main>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup-instructions" element={<SignupInstructions />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route
                  path="/business-type"
                  element={
                    <ProtectedRoute>
                      <BusinessType />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/representative-details"
                  element={
                    <ProtectedRoute>
                      <RepresentativeDetails />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/shop-details"
                  element={
                    <ProtectedRoute>
                      <ShopDetails />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/review-submit"
                  element={
                    <ProtectedRoute>
                      <ReviewSubmit />
                    </ProtectedRoute>
                  }
                />
                <Route 
                  path="/application-submitted" 
                  element={
                    <ProtectedRoute>
                      <ApplicationSubmitted />
                    </ProtectedRoute>
                  } 
                />
                {/* Future routes will be added here */}
              </Routes>
            </main>
          </div>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
